import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Button
} from 'reactstrap';

interface DescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave?: (desc: string) => void;
  initialValue?: string;
  title?: string;
}

const DescriptionModal: React.FC<DescriptionModalProps> = ({ isOpen, onClose, onSave, initialValue, title }) => {
  const [desc, setDesc] = useState(initialValue || '');
  const [loading, setLoading] = useState(false);

  // Simulate loading for demonstration (remove in production)
  // useEffect(() => {
  //   setLoading(true);
  //   const timer = setTimeout(() => setLoading(false), 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>{title ? title : 'Description'}</ModalHeader>
      <ModalBody style={{ position: 'relative', minHeight: 300 }}>
        <Form>
          <FormGroup className="mb-0" style={{ position: 'relative' }}>
            <Input
              type="textarea"
              className="form-control bg-body"
              value={desc}
              onChange={e => setDesc(e.target.value)}
              rows={12}
              style={{ minHeight: 250, background: '#fff', resize: 'none' }}
              disabled={loading}
            />
            {loading && (
              <div className="d-flex justify-content-center align-items-center" style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, pointerEvents: 'none' }}>
                <span style={{ color: 'limegreen', fontSize: 24, display: 'block' }}>●</span>
              </div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        {title === 'Extra Details' ? (
          <button className="btn btn-soft-dark btn-sm" style={{ minWidth: 80 }} onClick={onClose} disabled={loading}>Cancel</button>
        ): (
          <>
            <button className="btn btn-soft-success btn-sm" style={{ minWidth: 80 }} onClick={() => onSave?.(desc)} disabled={loading}>Save</button>
            <button className="btn btn-soft-danger btn-sm" style={{ minWidth: 80 }} onClick={() => setDesc('')} disabled={loading}>Clear</button>
            <button className="btn btn-soft-dark btn-sm" style={{ minWidth: 80 }} onClick={onClose} disabled={loading}>Cancel</button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DescriptionModal; 